import { render } from "./EditProjectMembers.vue?vue&type=template&id=6086faba"
import script from "./EditProjectMembers.vue?vue&type=script&lang=js"
export * from "./EditProjectMembers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__